import request from '../api';

// 1.获取上传临时令牌
export function getUploadCredentials() {
  return request.post('/app/virtualManApi/custom/getUploadCredentials');
}

// 2. 上传素材到腾讯云 COS
export function customUpload(data) {
  return request.post('/app/virtualManApi/custom/upload', {});
}

// 3.定制接口
export function customMake(data) {
  return request.post('/app/virtualManApi/custom/make', data);
}

// 4、进度查询接口
export function getProgress(data) {
  return request.post('/app/virtualManApi/custom/getProgress', {});
}

// 5.效果确认接口
export function customerConfirm(data) {
  return request.post('/app/virtualManApi/custom/customerConfirm', {});
}


// 获取用户可用定制资产
// TIMBRE: 音色定制
// VIRTUALMAN: 形象定制
// FLEXUS_MAN: 实景数字人形象
// PHOTO_MAN: 照片数字人形象
// SELF_PHOTO_VIDEO: 照片数字人视频制作
// SELF_VIRTUAL_MAN: 数字人视频生成视频
export const appUserResourceDics = {
  TIMBRE: {
    label: '音色定制',
    makeType: 'VOICE_TTS',
    tip: '适用于短视频、有声读物、播客等有声内容创作，塑造个性化听觉形象。',
    icon: 'ri-speak-ai-line',
    resourceType: 'TIMBRE',
    countValue: 'timbreCount',
  },
  VIRTUALMAN: {
    label: '形象定制',
    makeType: 'IMAGE_GENERAL',
    tip: '用于虚拟主播直播、品牌虚拟形象代言、社交媒体头像表情包制作等，增强品牌与用户互动。',
    icon: 'ri-user-line',
    resourceType: 'VIRTUALMAN',
    countValue: 'virtualManCount',
  },
  FLEXUS_MAN: {
    label: '实景数字人形象',
    makeType: 'FLEXUS_MAN',
    tip: '应用于实景旅游推广视频、线上沉浸式活动等，提升沉浸感与参与感。',
    icon: 'ri-robot-3-line',
    resourceType: 'FLEXUS_MAN',
    countValue: 'flexusManCount',
  },
  PHOTO_MAN: {
    label: '照片数字人形象',
    makeType: 'IMAGE_PHOTO',
    tip: '适用于人物传记视频、纪念性社交媒体图文等，赋予照片情感深度与吸引力。',
    icon: 'ri-camera-ai-line',
    resourceType: 'PHOTO_MAN',
    countValue: 'photoManCount',
  },
  SELF_PHOTO_VIDEO: {
    icon: 'ri-ghost-smile-line', // 圆润可爱的人形图标
    label: '照片数字人视频制作',
    tip: '用一张照片，让静态照片变成会说话的数字人视频，即将为您呈现', // 更新的tip文案
    makeType: 'SELF_PHOTO_VIDEO',
    recommended: true,
    path: '/img-digital-man',
    resourceType: 'SELF_PHOTO_VIDEO',
    countValue: 'selfPhotoVideoCount',
  },
  SELF_VIRTUAL_MAN: {
    icon: 'ri-video-chat-line', // 视频聊天图标
    label: '数字人视频生成视频',
    tip: '快速生成专业的数字人视频内容,支持多场景应用',
    makeType: 'SELF_VIRTUAL_MAN',
    recommended: true,
    path: '/digital-video-maker',
    resourceType: 'SELF_VIRTUAL_MAN',
    countValue: 'selfVirtualManCount',
  },
};

// 检查makeType是否存在
export const hasMakeType = (makeType: string): boolean => {
  return Object.values(appUserResourceDics).some((item) => item.makeType === makeType);
};

// 获取定制分页列表
export const customMakeStatus = {
  CREATING: '正在创建',
  MAKING: '制作中',
  FAIL: '失败',
  SUCCESS: '训练完成等待确定',
  AGREE: '认同',
  REJECT: '驳回',
  CANCEL: '已取消',
};

// 定义状态颜色
export const customMakeStatusColor = {
  CREATING: '#FF8C00', // 深橙色
  MAKING: '#1E90FF', // 道奇蓝
  FAIL: '#FF4500', // 橙红色
  SUCCESS: '#32CD32', // 酸橙绿
  AGREE: '#7CFC00', // 草坪绿
  REJECT: '#8A2BE2', // 蓝紫色
};

export function appUserResource(data) {
  return request({
    url: '/app/userResource/appUserResource',
    method: 'post',
    data,
  });
}

// 资源文件
export const MediaFileType = {
  IMAGES: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp'],
  AUDIOS: ['.mp3', '.wav', '.aac', '.ogg', '.flac'],
  VIDEOS: ['.mp4', '.avi', '.mkv', '.mov', '.wmv', '.flv'],
  DOCUMENTS: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt', '.rtf', '.odt', '.ods', '.odp'],
  UNKNOWN: [],
};

export const ext = (url) => url.split('.').pop().toLowerCase();
export class MediaType {
  static TYPES = MediaFileType;

  static get(type) {
    return Object.keys(this.TYPES).find((t) => this.TYPES[t].includes(type));
  }
}

// 获取上传临时令牌
export const uploadCredentials = (data = {}) => {
  return request({
    url: '/app/custom/uploadCredentials',
    method: 'post',
    data,
  });
};

// 图片检测
export const customCheckPhoto = (data = {}) => {
  return request({
    url: '/app/custom/checkPhoto',
    method: 'post',
    data,
  });
};

// 添加定制
export const customCustomMake = (data = {}) => {
  return request({
    url: '/app/custom/customMake',
    method: 'post',
    data,
  });
};

export function getAppTencentCustomMakePage(data) {
  return request({
    url: '/app/tencentCustomMake/getAppTencentCustomMakePage',
    method: 'post',
    data,
  });
}

// 确认定制结果
export const customConfirmMake = (data) => {
  return request({
    url: '/app/custom/confirmMake',
    method: 'post',
    data,
  });
};
// 取消定制
export const customCancel = (makeId) => {
  return request({
    url: `/app/custom/cancel/${makeId}`,
    method: 'post',
  });
};

// 获取App腾讯定制详情
export const getAppTencentCustomMake = (id) => {
  return request({
    url: `/app/tencentCustomMake/getAppTencentCustomMake/${id}`,
    method: 'post',
  });
};

// 音色列表
export const timbreGetTimbrePage = (data) => {
  return request({
    url: '/app/timbre/getAppTimbrePage',
    method: 'post',
    data,
  });
};

// APP创建视频-照片
export const createVideoByPhoto = (data) => {
  return request({
    url: '/app/video/createVideoByPhoto',
    method: 'post',
    data,
  });
};
// APP创建视频-视频
export const createVideoByVideo = (data) => {
  return request({
    url: '/app/video/createVideoByVideo',
    method: 'post',
    data,
  });
};
